<template>
    <div>
        <div class="choose-type-header">
            <MorningstarLogo class="choose-type-header__logo" v-if="settings.showBanner" />
            <mds-button-container>
                <mds-button variation="secondary" v-if="settings.showSignOut" @click="handleSignOut">{{ getUILabel("common_sign_out") }}</mds-button>
            </mds-button-container>
        </div>
    </div>
</template>

<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MorningstarLogo from "@/assets/MorningstarLogo.vue";

export default {
    name: "choose-type-header",
    components: {
        MdsButton,
        MdsButtonContainer,
        MorningstarLogo
    },
    mixins: [MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                settings: {
                    showSignOut: false,
                    showBanner: false
                }
            }
        };
    },
    methods: {
        handleSignOut() {
            this.$emit("sign-out");
        }
    }
};
</script>

<style lang="scss" scoped>
.choose-type-header {
    display: flex;
    height: 50px;
    border-bottom: $mds-border-separator;
    padding: 10px 0px;
    &__logo {
        transform: translateX(-50%);
        margin-left: 50%;
        + .mds-button-container___hypo {
            flex: 1 0 auto;
        }
    }
    .mds-button-container___hypo {
        margin-left: auto;
        justify-content: flex-end;
    }
}
</style>
